import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { getReferralTypeLabel, getReferralTypeColorFamily } from '../referrals/ReferralModal';
import './PendingReferralsList.css';
import { StatusBadge } from '@medprompt/shared';

const formatDate = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('en-GB', {
      day: '2-digit', month: 'short', year: 'numeric'
    });
  } catch {
    return iso;
  }
};

/**
 * Shared component that renders a list of pending referrals.
 * Used identically in PendingReferralsModal and PatientDiaryPanel.
 */
const PendingReferralsList = ({ referrals = [], onReferralClick }) => {
  if (!referrals || referrals.length === 0) {
    return (
      <div className="pending-referrals-empty">
        <em>No pending referrals</em>
      </div>
    );
  }

  return (
    <div className="pending-referrals-list">
      {referrals.map((referral) => (
        <div
          key={referral.referralId}
          className="pending-referral-item"
          onClick={() => onReferralClick && onReferralClick(referral)}
          title="Click to open referral"
        >
          <div className="pending-referral-item-left">
            <StatusBadge
              label={getReferralTypeLabel(referral.referralType)}
              colorFamily={getReferralTypeColorFamily(referral.referralType)}
              size="small"
            />
            <span className="pending-referral-date">
              {formatDate(referral.referredAt)}
            </span>
          </div>
          <div className="pending-referral-notes">
            {referral.text || <em>No notes</em>}
          </div>
          <FontAwesomeIcon icon={faChevronRight} className="pending-referral-chevron" />
        </div>
      ))}
    </div>
  );
};

export default PendingReferralsList;
